import { useTraduccion } from '@tallerya/i18n';
import { PanelLateral } from '@tallerya/ui';
import { textoDeEntrada, type Campos } from '../../componentes/historial/cambios';
import { LineaDeTiempo } from '../../componentes/historial/LineaDeTiempo';
import { useHistorialProveedor } from './datos';

// El panel «Historial» de la ficha del proveedor (#188), con la línea de tiempo
// común. Lo de acá es cómo se lee cada cambio:
//
// - **El código, el nombre y el número de documento no dicen a qué cambiaron**:
//   un proveedor puede ser una persona, y la auditoría nunca los guardó. Se juntan
//   en «Cambió: nombre, número de documento».
// - **El tipo de documento llega por su código** —«NIT → DUI»—, y la referencia,
//   tal cual.

export function PanelHistorial({
  proveedorId,
  abierto,
  onCerrar,
}: {
  proveedorId: string;
  abierto: boolean;
  onCerrar: () => void;
}) {
  const { t } = useTraduccion();
  const consulta = useHistorialProveedor(proveedorId, abierto);

  const campos: Campos = {
    code: { etiqueta: t('admin.proveedores.formulario.codigo') },
    name: { etiqueta: t('admin.proveedores.formulario.nombre') },
    doc_type_id: {
      etiqueta: t('admin.proveedores.formulario.tipoDocumento'),
      vacio: t('admin.proveedores.formulario.sinDocumento'),
    },
    doc_identifier: { etiqueta: t('admin.proveedores.formulario.numeroDocumento') },
    reference: { etiqueta: t('admin.proveedores.formulario.referencia') },
  };

  return (
    <PanelLateral abierto={abierto} onCerrar={onCerrar} titulo={t('admin.historial.titulo')} info={t('admin.proveedores.historial.info')}>
      <LineaDeTiempo consulta={consulta} texto={(entrada) => textoDeEntrada(entrada, campos, t)} />
    </PanelLateral>
  );
}
